import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-efe4160e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "popup-content" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "triangle-up" }, null, -1))
const _hoisted_3 = ["onClick"]
const _hoisted_4 = ["onClick"]
const _hoisted_5 = {
  key: 0,
  class: "asahi-icon-quantity"
}
const _hoisted_6 = { key: 1 }
const _hoisted_7 = ["href"]
const _hoisted_8 = {
  key: 2,
  class: "mb-0"
}
const _hoisted_9 = {
  key: 1,
  class: "loader"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LoaderSpinner = _resolveComponent("LoaderSpinner")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.open)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass(["asahi-popup-container", {'customized': _ctx.customized}])
        }, [
          _createElementVNode("div", _hoisted_1, [
            _hoisted_2,
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options, (option) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "asahi-option",
                key: option.name,
                onClick: ($event: any) => (_ctx.handleMenuClick(option))
              }, [
                (option.href && option?.name !== 'Szkolenia 2' && option?.name !== 'Karta menu 3' && option?.name !== 'Beercoin 10' && option?.name !== 'Logout')
                  ? (_openBlock(), _createElementBlock("a", {
                      key: 0,
                      href: "javascript:void(0);",
                      onClick: ($event: any) => (_ctx.onClickMenuItem(option.href, option.name)),
                      class: _normalizeClass(option.name === 'Notifications' ? 'notifications-link' : '')
                    }, [
                      _createTextVNode(_toDisplayString(_ctx.$t(option.label)) + " ", 1),
                      (option?.name === 'Notifications' && _ctx.iconQuantity)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(_ctx.iconQuantity), 1))
                        : _createCommentVNode("", true)
                    ], 10, _hoisted_4))
                  : (option?.name === 'Karta menu 3')
                    ? (_openBlock(), _createElementBlock("span", _hoisted_6, [
                        _createElementVNode("a", {
                          href: option?.href,
                          class: "external-link"
                        }, _toDisplayString(option.label), 9, _hoisted_7)
                      ]))
                    : (_openBlock(), _createElementBlock("p", _hoisted_8, _toDisplayString(_ctx.$t(option.label)), 1))
              ], 8, _hoisted_3))
            }), 128))
          ])
        ], 2))
      : _createCommentVNode("", true),
    (_ctx.isLoading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
          _createVNode(_component_LoaderSpinner)
        ]))
      : _createCommentVNode("", true)
  ], 64))
}